import { useMemo } from 'react';

const orionUID = () => {
  return 'xxxx-xxxx-xxx-xxxx'.replace(/[x]/g, (c) => {
    const r = Math.floor(Math.random() * 16);
    return r.toString(16);
  });
};

export const useOrionUID = () => useMemo(() => orionUID(), []);
